/* eslint-disable no-undef */
import React, { useEffect, useState } from 'react'
import { decode, isValid } from 'js-base64'
import { useLocation } from 'react-router'
import DashboardBoldBI from '../../commons/DashboardBoldbi/DashboardBoldBi'

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

const DashboardMobile = () => {
  const query = useQuery()
  const data = query.get('data')
  const [config, setConfig] = useState()

  useEffect(() => {
    if (isValid(data)) {
      const decoded = decode(data)
      const dashboard = JSON.parse(decoded)

      setConfig({
        serverUrl: dashboard.serverUrl,
        dashboardId: dashboard.dashboardId,
        authorizationServer: dashboard.authorizationServer,
        height: dashboard.height
      })
    }
  }, [data])

  return config ? (
    <DashboardBoldBI id="dashboard-mobile" config={config} />
  ) : (
    <></>
  )
}

export default DashboardMobile
